module.exports = __webpack_public_path__ + "img/38_bohle.bcca8e2e.jpeg";